import "rxjs/add/operator/filter";
import "rxjs/add/operator/throttleTime";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";

import { AccountComponent } from "app/account/account.component";
import { AccountRoutingModule } from "app/account/account-routing.module";
import { ComponentsModule } from 'app/client/components/main/components.module';
import { ServiceModule } from "app/services/service.module";

import { AuthenticationService } from "app/services/authentication.service";
import { HttpBackendService } from "app/services/http-backend.service";


@NgModule({
    declarations: [
        AccountComponent
    ],
    imports: [
        ServiceModule,
        CommonModule,
        AccountRoutingModule,
        ComponentsModule
    ]
})
export class AccountModule {
    constructor(
        httpBackendService: HttpBackendService,
        authenticationService: AuthenticationService,
        router: Router
    ) {
        httpBackendService.errors()
            .filter(error => error.error instanceof Response && error.error.status == 401)
            .map(x => null)
            .auditTime(200)
            .merge(authenticationService.authenticatedUserChange
                .distinctUntilChanged()
                .filter(user => user == null || user == undefined))
            .subscribe(_ => {
                router.navigateByUrl("/account/signin");
            });
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/account/account.module.ts